import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetItemProgramsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemProgramDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemProgramDocumentSortInput> | Types.ItemProgramDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetItemProgramsQuery = { __typename?: 'Query', itemPrograms?: { __typename?: 'ItemProgramsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemProgramDocument', itemId: string, program: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetItemProgramsDocument = new TypedDocumentString(`
    query GetItemPrograms($where: ItemProgramDocumentFilterInput, $order: [ItemProgramDocumentSortInput!], $first: Int, $after: String) {
  itemPrograms(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      itemId
      program
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItemPrograms: build.query<GetItemProgramsQuery, GetItemProgramsQueryVariables | void>({
      query: (variables) => ({ document: GetItemProgramsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemProgramsQuery, useLazyGetItemProgramsQuery } = injectedRtkApi;
